<script lang="ts">
  export const size: any = 24;
</script>

<svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M79.4198 38.2799L75.8265 53.6065C72.7465 66.8432 66.6598 72.1965 55.2198 71.0965C53.3865 70.9499 51.4065 70.6199 49.2798 70.1065L43.1198 68.6399C27.8298 65.0099 23.0998 57.4565 26.6932 42.1299L30.2865 26.7665C31.0198 23.6499 31.8998 20.9365 32.9998 18.6999C37.2898 9.82653 44.5865 7.4432 56.8332 10.3399L62.9565 11.7699C78.3198 15.3632 83.0132 22.9532 79.4198 38.2799Z"
    class={$$props.class || "stroke-garden-grey-600"}
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M55.2198 71.0969C52.9465 72.6369 50.0865 73.9202 46.6031 75.0569L40.8098 76.9635C26.2531 81.6569 18.5898 77.7335 13.8598 63.1769L9.16645 48.6935C4.47312 34.1369 8.35979 26.4369 22.9165 21.7435L28.7098 19.8369C30.2131 19.3602 31.6431 18.9569 32.9998 18.7002C31.8998 20.9369 31.0198 23.6502 30.2865 26.7669L26.6931 42.1302C23.0998 57.4569 27.8298 65.0102 43.1198 68.6402L49.2798 70.1069C51.4065 70.6202 53.3865 70.9502 55.2198 71.0969Z"
    class={$$props.class || "stroke-garden-grey-600"}
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
